const components = {
  Analyse: () => import('@/connectors/components/Analyse/Analyse'),
  Overview: () => import('@/connectors/components/Overview'),
  Sources: () => import('@/connectors/components/Sources/Sources'),
  SourceEditor: () => import('@/connectors/components/Sources/SourceEditor'),
  Jobs: () => import('@/connectors/components/Jobs/Jobs'),
  JobDetails: () => import('@/connectors/components/Jobs/JobDetails'),
  RouterRedirectDataplantId: () => import('@/shared/RouterRedirectDataplantId'),
  Consumers: () => import('@/connectors/components/Consumers/Consumers'),
  ConsumerEditor: () => import('@/connectors/components/Consumers/ConsumerEditor'),
  TrinoConsumerEditor: () => import('@/connectors/components/Consumers/TrinoConsumerEditor'),
  CustomSources: () => import('@/connectors/components/CustomSources/CustomSources'),
  CustomSourceDetails: () => import('@/connectors/components/CustomSources/CustomSourceDetails')
}

const routes = [
  {
    path: '/',
    name: 'Connectors',
    component: components.RouterRedirectDataplantId,
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },
  {
    path: '/:dataplantId/',
    name: 'Connectors - Overview',
    display_name: 'searchbar.items.dc.overview.display_name',
    description: 'searchbar.items.dc.overview.description',
    searchable: true,
    component: components.Overview,
    meta: {
      analytics: { category: 'dashboard' },
      ready: ['dm_databases']
    }
  },
  {
    path: '/:dataplantId/sources',
    name: 'Connectors - Sources',
    display_name: 'searchbar.items.dc.sources.display_name',
    description: 'searchbar.items.dc.sources.description',
    searchable: true,
    component: components.Sources,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Sources - ${parent(route, false)}`,
      ready: ['dm_databases']
    }
  },
  {
    path: '/:dataplantId/custom-sources',
    name: 'Connectors - Custom Sources',
    display_name: 'searchbar.items.dc.custom_sources.display_name',
    description: 'searchbar.items.dc.custom_sources.description',
    searchable: true,
    component: components.CustomSources,
    meta: {
      title: (route, parent) => `Custom Sources - ${parent(route, false)}`,
      ready: ['iam_users']
    }
  },
  {
    path: '/:dataplantId/custom-sources/:id',
    name: 'Connectors - Custom Source',
    component: components.CustomSourceDetails,
    meta: {
      title: (route, parent) => `Custom Source - ${parent(route, false)}`,
      ready: ['dm_databases']
    }
  },
  {
    path: '/:dataplantId/source',
    name: 'Connectors - New Source',
    component: components.SourceEditor,
    meta: {
      analytics: { category: 'funnel' },
      title: (route, parent) => `Source - ${parent(route, false)}`,
      ready: ['dm_databases']
    }
  },
  {
    path: '/:dataplantId/source/:id',
    name: 'Connectors - Edit Source',
    component: components.SourceEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Source - ${parent(route, false)}`,
      ready: ['dm_databases', 'ds_buckets']
    }
  },
  {
    path: '/:dataplantId/analyzer',
    name: 'Connectors - Analyzer',
    display_name: 'searchbar.items.dc.analyzer.display_name',
    description: 'searchbar.items.dc.analyzer.description',
    searchable: true,
    component: components.Analyse,
    meta: {
      analytics: { category: 'exploration' },
      title: (route, parent) => `Analyzer - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_rules']
    }
  },
  {
    path: '/:dataplantId/analyzer/database/:databaseId/table/:tableId',
    name: 'Connectors - Analyzer Table',
    component: components.Analyse,
    meta: {
      analytics: { category: 'exploration' },
      title: (route, parent) => `Analyzer - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_rules']
    }
  },
  {
    path: '/:dataplantId/jobs',
    name: 'Connectors - Jobs',
    display_name: 'searchbar.items.dc.jobs.display_name',
    description: 'searchbar.items.dc.jobs.description',
    searchable: true,
    component: components.Jobs,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Jobs - ${parent(route)}`,
      ready: ['dm_jobs']
    }
  },
  {
    path: '/:dataplantId/job/:id',
    name: 'Connectors - Job Details',
    component: components.JobDetails,
    meta: {
      analytics: { category: 'details' },
      title: (route, parent) => `Jobs - ${parent(route)}`,
      ready: ['dm_jobs']
    }
  },
  {
    path: '/:dataplantId/consumers',
    name: 'Connectors - Consumers',
    display_name: 'searchbar.items.dc.consumers.display_name',
    description: 'searchbar.items.dc.consumers.description',
    searchable: true,
    component: components.Consumers,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Consumers - ${parent(route)}`,
      ready: ['iam_users', 'consumers', 'iam_roles']
    }
  },
  {
    path: '/:dataplantId/consumer/:id?',
    name: 'Connectors - Edit Consumer',
    component: components.ConsumerEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Consumer - ${parent(route, false)}`,
      ready: ['consumers', 'iam_roles']
    }
  },
  {
    path: '/:dataplantId/consumer/trino/:id?',
    name: 'Connectors - Edit Trino Consumer',
    component: components.TrinoConsumerEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Trino Consumer - ${parent(route, false)}`,
      ready: ['consumers', 'iam_roles']
    }
  },
  {
    path: '/:dataplantId/:pathMatch(.*)',
    redirect: { name: 'Connectors' }
  }
]

export const basePath = 'connectors/'
export default routes
